// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_2h-1";
export var rateTableServiceLevelDropdown = "_2h-3";
export var rateTableTypeDropdown = "_2h-0";
export var rateTableValueModeDropdown = "_2h-2";